export default __webpack_public_path__ + "static/hero-605c9a683a4c31006ddacd49da18b020.jpeg";